<template>
  <div class="law-page">
    <div class="top-banner">
      <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/product-bg.png" alt="Banner" class="banner-image" />

      <div class="banner-info">
        <div class="title">医疗器械注册服务</div>
        <div class="space"></div>
        <div class="info">提供从产品分类、检测方案、临床评价到申报资料编制的全流程精细化服务。凭借丰富的成功案例与高效沟通，助您精准合规、缩短周期、降低成本，让创新产品安全快速抵达市场。为医疗器械产品的成功上市，保驾护航。</div>
        <div class="btn">
          <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/btn.png" class="btn" alt="">
        </div>
      </div>
    </div>

    <div class="page-main">
      <div class="section-title">
        <h2>NMPA注册服务流程</h2>
        <div class="title-underline"></div>
      </div>

      <div class="img-box">
        <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/register-1.png" alt="">
      </div>

      <div class="section-title">
        <h2>您身边的医疗器械法规专家</h2>
        <div class="title-underline long"></div>
      </div>

      <div class="img-box">
        <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/register-2.png" alt="">
      </div>

      <div class="section-title clear">
        <h2>注册服务及优势</h2>
        <div class="title-underline"></div>
      </div>

      <div class="img-box clear">
        <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/register-3.png" alt="">
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
</script>

<style lang="less" scoped>
.law-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  padding-bottom: 30px;
  .banner-info {
    position: absolute;
    right: 100px;
    top: 0;
    height: 600px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    .title {
      font-family: YouSheBiaoTiHei;
      font-size: 72px;
      line-height: 90px;
      color: #101010;
    }
    .space {
      width: 160px;
      height: 24px;
      margin: 32px 0 44px;
      background: linear-gradient(228.23deg, rgba(35,19,176,0.83) 12.42%,rgba(128,152,219,0.9) 47.6%,rgba(135,183,219,0.82) 73.98%,rgba(165,227,255,0.75) 97.43%);
    }
    .info {
      width: 820px;
      
      font-size: 20px;
      line-height: 35px;
      color: #101010;
      text-align: right;
    }
    .btn {
      margin-top: 40px;
      img {
        width: 200px;
        cursor: pointer;
        transition: all .3s;
        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }

  .top-banner {
    width: 100%;
    height: 600px;
    overflow: hidden;

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
}

.page-main {
  width: 1400px;
  margin: 0 auto;
  padding: 40px 0;
  .section-title {
    text-align: left;
    margin-bottom: 60px;
    &.clear {
      margin-bottom: 20px;
    }
    
    h2 {
      
      font-size: 48px;
      color: #101010;
      margin-bottom: 10px;
    }
    
    .title-underline {
      width: 440px;
      height: 7px;
      background: #1e40af;
      &.long {
        width: 600px;
      }
    }
  }
}

.img-box {
  margin-bottom: 100px;
  &.clear {
    margin-bottom: 0;
  }
  img {
    width: 100%;
  }
}



// 小分比率适配
@media screen and (max-width: 1560px) {
  .law-page {
    min-width: 1200px;
    .top-banner {
      height: 540px;
      .banner-info {
        height: 540px;
        .title {
          font-size: 66px;
          line-height: 84px;
        }
        .space {
          height: 22px;
        }
        .info {
          font-size: 18px;
        }
        .btn {
          margin-top: 34px;
        }
      }
    }

    .page-main {
      width: 1200px;
      .section-title {
        margin-bottom: 52px;
        h2 {
          font-size: 42px;
        }
        .title-underline {
          width: 380px;
          height: 6px;
          &.long {
            width: 540px;
          }
        }
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1400px) {
  .law-page {
    min-width: 1080px;
    .top-banner {
      height: 500px;
      .banner-info {
        height: 500px;
        .title {
          font-size: 60px;
          line-height: 72px;
        }
        .space {
          height: 20px;
        }
        .info {
          font-size: 16px;
        }
        .btn {
          margin-top: 30px;
        }
      }
    }

    .page-main {
      width: 1080px;
      .section-title {
        margin-bottom: 36px;
        h2 {
          font-size: 36px;
        }
        .title-underline {
          width: 350px;
          height: 5px;
          &.long {
            width: 460px;
          }
        }
      }
    }
  }
}
</style>